import { useMemo } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';

import GREQTaskPartnerLink from 'components/atoms/PKUrl/GREQTaskPartnerLink';
import { equalOrThreeDashes } from 'utils/equalOrThreeDashes';
import { joinString } from 'utils/string';

export const PartnerTableRow = ({ taskId, partner = {} }) => {
	const formattedAddress = useMemo(() => {
		const { address } = partner;

		if (!address) {
			return equalOrThreeDashes();
		} else {
			return (
				<>
					{joinString(' ', [address?.street, address?.streetNo])},&nbsp;
					{joinString(' ', [address?.zipCode, address?.municipality])}
				</>
			);
		}
	}, [partner]);

	const formattedPartnerName = useMemo(() => {
		const { businessName, firstName, surname } = partner;
		let finalPartnerName;

		if (businessName) {
			finalPartnerName = businessName;
		} else if (surname && firstName) {
			finalPartnerName = `${surname} ${firstName}`;
		}

		return <>{finalPartnerName}</>;
	}, [partner]);

	return (
		<>
			<TableCell>
				{partner.canRedirectToGreq ? (
					<GREQTaskPartnerLink taskId={taskId} partnerId={partner.id} muiLink>
						{formattedPartnerName}
					</GREQTaskPartnerLink>
				) : (
					formattedPartnerName
				)}
			</TableCell>
			<TableCell>{partner.birthNumber}</TableCell>
			<TableCell>{formattedAddress}</TableCell>
		</>
	);
};

PartnerTableRow.propTypes = {
	partner: PropTypes.any,
	taskId: PropTypes.number,
};

export default PartnerTableRow;
